import React from 'react';
import logo from 'assets/images/logo.png';

// ===========================|| LOGO PNG ||=========================== //

const Logo = () => <img src={logo} alt="Logo Youth HCMUTE" width="150" />;

export default Logo;
